const cuiBaseLocale = require('cuiBaseLocale');
const cuiMessageLocale = require('cuiMessageLocale');
const GameLocale = require('GameLocale') || {};

module.exports = {
    getDefinitions: () => {
        const locale = cuiBaseLocale;
        // merge the objects
        for (const prop in locale) {
            if (GameLocale.hasOwnProperty(prop)) {
                cc.js.mixin(locale[prop], GameLocale[prop]);
            }
            if (cuiMessageLocale.hasOwnProperty(prop)) {
                cc.js.mixin(locale[prop], cuiMessageLocale[prop]);
            }
        }

        // and return it
        return locale;
    }

};
